const short = require('short-uuid');

const translator = short.createTranslator();

/** Convert a full UUID to a ~22-char base57 string */
export const toShort = (uuid: string): string => translator.fromUUID(uuid);

/** Convert a short UUID back to a full UUID (lowercase, with hyphens) */
export const fromShort = (shortId: string): string => translator.toUUID(shortId);

/** Test whether a string is a full UUID (8-4-4-4-12 hex with hyphens) */
export const isFullUuid = (str: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str);

/** Accept either a full UUID or a shortUUID and always return a full UUID */
export const resolveId = (id: string): string => (isFullUuid(id) ? id : fromShort(id));
